import React, { useEffect } from "react";
import history from "../../../../../utils/history";
import Panel from "../../../../ui/panel/Panel";
import Text from "../../../../ui/text/Text";
import "./PositiveOneTimeChargeSuccessfullyCapturedEmailTemplate.scss";
import { AppState } from "../../../../..";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-grid-system";
import EmailPreivewContainer from "../../brand-customization/email-preview/EmailPreivewContainer";
import BackNavigationPanel from "../../../../ui/back-navigation-panel/BackNavigationPanel";
import { resetEmailTemplateValues, getEmailTemplateValues } from "../../../../../actions/emailCustomizationActions";
import { fetchCompanyBranding } from "../../../../../actions/companyBrandingActions";
import EmailFooter from "../email-footer/EmailFooter";
import EmailEditableArea from "../email-editable-area/EmailEditableArea";
import { IAuthReducerState } from "../../../../../reducers/authReducer";
import { ICompanyBrandingReducerState } from "../../../../../reducers/companyBrandingReducer";
import { IEmailCustomizationReducerState } from "../../../../../reducers/emailCustomizationReducer";
import { EmailTypes } from "../../../../../utils/grpc/generated/Billsby.Protos/Messenger/private/emailconfig/emailconfig_pb";


const PositiveOneTimeChargeSuccessfullyCapturedEmailTemplate: React.FC = () => {

  const dispatch = useDispatch();
  const authReducer = useSelector<AppState, IAuthReducerState>(state => state.auth);
  const potcsc_companyBrandingReducer = useSelector<AppState, ICompanyBrandingReducerState>(state => state.companyBrandingReducer);
  const potcsc_emailCustomizationReducer = useSelector<AppState, IEmailCustomizationReducerState>(state => state.emailCustomizationReducer);
  const { customArea1, customArea2 } = potcsc_emailCustomizationReducer;
  const { currentCompanyId, companyName, currentCompanyDomain } = authReducer;
  const { highlightColor } = potcsc_companyBrandingReducer;
  const defaultHighLightColor = "#F87847";

  useEffect(() => {
    dispatch(fetchCompanyBranding(currentCompanyDomain));
    dispatch(getEmailTemplateValues(currentCompanyId as number, companyName, EmailTypes.POSITIVE_ONE_TIME_CHARGE));
    return () => { dispatch(resetEmailTemplateValues()) };
  }, []);

  return (
    <div id="PositiveOneTimeChargeSuccessfullyCapturedEmailTemplate-wrapper">
      <BackNavigationPanel
        title={"EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BACK_PANEL_TITLE"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/email-notifications/emails/payment-credits-refund")} />

      <Row>
        <Col sm={8}>
          <Panel className="payment-details-request-email-template__panel" noMargin>
            <EmailPreivewContainer>

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea1}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text email-preview__details__text-title bar bar-blue"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_GREETINGS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea2}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text bar bar-orange"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_1"
                className="email-preview__details__text email-preview__details__text-bold"
                component="span"
                noMargin
              />

              <Row>
                <Col md={4}>
                  <Text
                    content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_2"
                    className="email-preview__details__text email-preview__details__text-no-margin"
                    component="span"
                    noMargin
                  />
                </Col>
                <Col md={8}>
                  <Text
                    content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_3"
                    className="email-preview__details__text email-preview__details__text-no-margin"
                    component="span"
                    noMargin
                  />
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Text
                    content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_4"
                    className="email-preview__details__text email-preview__details__text-no-margin"
                    component="span"
                    noMargin
                  />
                </Col>
                <Col md={8}>
                  <Text
                    content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_5"
                    className="email-preview__details__text email-preview__details__text-no-margin"
                    component="span"
                    noMargin
                  />
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Text
                    content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_6"
                    className="email-preview__details__text"
                    component="span"
                    noMargin
                  />
                </Col>
                <Col md={8}>
                  <Text
                    content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_7"
                    className="email-preview__details__text"
                    component="span"
                    noMargin
                  />
                </Col>
              </Row>
              
              <Text
                content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_BODY_8"
                className="email-preview__details__text"
                component="span"
                noMargin
                style={{textDecoration: "underline", cursor: "pointer", color: !!highlightColor ? highlightColor : defaultHighLightColor}}
              />

              <Text
                content="EMAIL_TEMPLATE_POSITIVE_ONE_TIME_CHARGE_CAPTURED_SUCCESSFULLY_REAGRDS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={companyName}
                className="email-preview__details__text"
                component="span"
                shouldTranslate={false}
                noMargin
              />
              <EmailFooter />
            </EmailPreivewContainer>
          </Panel>
        </Col>
        <Col sm={4}>
          <EmailEditableArea
            id="PositiveOneTimeChargeSuccessfullyCapturedEmailTemplate"
            emailCustomCopyOneValue={customArea1}
            emailCustomCopyTwoValue={customArea2}
            emailCustomCopyThreeValue=""
            emailCustomCopyThreeIsVisible={false}
            showCompanyAlertToggle={true}
            showProductAlertToggle={false}
            showPlanAlertToggle={false}
          />
        </Col>
      </Row>
    </div>
  )
}

export default PositiveOneTimeChargeSuccessfullyCapturedEmailTemplate